import { ProductVenderMappingConstants } from "../constants";
export function ProductVenderMapping(state = {}, action) {
    switch (action.type) {
        case ProductVenderMappingConstants.LOADING_REQUEST:
            return {
                ...state,
                loding: action.isbool
            };
        case ProductVenderMappingConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case ProductVenderMappingConstants.GETALL_SUCCESS:
            return {
                ...state,
                secondaryitems: action.datas
            };
        case ProductVenderMappingConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case ProductVenderMappingConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case ProductVenderMappingConstants.GETEXPORT_SUCCESS:

            return {
                ...state,
                exportitems: action.datas,
                isDownload: state.isDownload == null ? 1 : state.isDownload + 1
            };
        case ProductVenderMappingConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case ProductVenderMappingConstants.GETVENDORDDL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case ProductVenderMappingConstants.GETVENDORDDL_SUCCESS:
            return {
                ...state,
                vendorDDL: action.datas
            };
        case ProductVenderMappingConstants.GETVENDORDDL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case ProductVenderMappingConstants.GETVENDORPRODUCT_REQUEST:
            return {
                ...state,
                error: action.error,
                VendorProducts: []

            };
        case ProductVenderMappingConstants.GETVENDORPRODUCT_SUCCESS:
            return {
                //vendorproduct:action.error
                ...state,
                loading: false,
                VendorProducts: action.datas
            };
        case ProductVenderMappingConstants.GETVENDORPRODUCT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            }
        case ProductVenderMappingConstants.GETPDDL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case ProductVenderMappingConstants.GETPDDL_SUCCESS:
            return {
                ...state,
                ProductDDList: action.datas
            };
        case ProductVenderMappingConstants.GETPDDL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case ProductVenderMappingConstants.CREATE_REQUEST:
            return {
                ...state,
                creating: true
            };
        case ProductVenderMappingConstants.CREATE_SUCCESS:
            return {
                ...state,
                items: [action.data, ...(state.items || [])],
                creating: false
            };

        case ProductVenderMappingConstants.UPLOAD_SO_REQUEST:
            return {
                ...state,
                creating: true,
            };
        case ProductVenderMappingConstants.UPLOAD_SO_SUCCESS:
            return {
                ...state,
            };
        case ProductVenderMappingConstants.UPLOAD_SO_PARTIAL_SUCCESS:
            return {
                ...state,
                showErrorDialog: true,
                ErrorData: action.datas,
            };
        case ProductVenderMappingConstants.UPLOAD_SO_FAILURE:
            return {
                ...state,
                error: action.error,
            };

        default:
            return state
    }

}